var $6b17f08f738443dc$exports = {};
function $6b17f08f738443dc$var$removeHtmlExtension() {
    var url = window.location.href;
    var cleanUrl = url.replace(/\.html$/, '');
    var noIndex = cleanUrl.replace('index', '');
    history.replaceState({}, document.title, noIndex);
}
$6b17f08f738443dc$var$removeHtmlExtension();
"use strict";
window.Webflow ||= [];
window.Webflow.push(async ()=>{});


//# sourceMappingURL=401.2915bb65.js.map
